<h4 class="settings-header">
   {{ 'brick.brick_definitions.single_call_tag_editor.settings.header_presentation' | translate }}
</h4>
<div>
   <div class="sam-form-flex-row sam-border-box sam-padding-top">
      <label fxFlex="40" class="align-center">{{
         'brick.brick_definitions.single_call_tag_editor.settings.tab_presentation_type' | translate
      }}</label>
      <kendo-dropdownlist
         [data]="presentationTypePossibleValues"
         [value]="presentationType$ | async"
         class="k-form-field sam-form-control sam-full-width sam-flex-end"
         [valuePrimitive]="false"
         [valueField]="'value'"
         [textField]="'value'"
         (selectionChange)="presentationTypeChangedChanged($event)"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.translationKey | translate }}
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-flex-row sam-border-box">
      <label fxFlex="40" class="align-center">{{
         'brick.brick_definitions.single_call_tag_editor.settings.tag_icon' | translate
      }}</label>
      <div class="k-form-field sam-form-control sam-full-width sam-flex-end">
         <samweb-icon-picker
            fxFlex="1 1 auto"
            [value]="(settings$ | async).tagIcon | iconNameToIconDefinition$ | async"
            (valueChanged)="iconChanged($event)"
         >
         </samweb-icon-picker>
         <kendo-colorpicker
            [format]="'hex'"
            [gradientSettings]="{ opacity: false }"
            [view]="'gradient'"
            [value]="(settings$ | async).tagIconColor"
            (valueChange)="iconColorChanged($event)"
         ></kendo-colorpicker>
         <samweb-clear-button [toolTipText]="'common.clear_color' | translate" (click)="clearIconColor()">
         </samweb-clear-button>
      </div>
   </div>

   <div class="sam-form-flex-row sam-border-box">
      <label fxFlex="40" class="align-center">{{
         'brick.brick_definitions.single_call_tag_editor.settings.background_color' | translate
      }}</label>
      <div class="k-form-field sam-form-control sam-full-width sam-flex-end">
         <kendo-colorpicker
            [format]="'hex'"
            [gradientSettings]="{ opacity: false }"
            [view]="'gradient'"
            [value]="(settings$ | async).tagEditBackgroundColor"
            (valueChange)="backgroundColorChanged($event)"
         ></kendo-colorpicker>
         <samweb-clear-button [toolTipText]="'common.clear_color' | translate" (click)="clearBackgroundColor()">
         </samweb-clear-button>
      </div>
   </div>

   <div class="sam-form-flex-row sam-border-box">
      <label fxFlex="40" class="align-center">{{
         'brick.brick_definitions.single_call_tag_editor.settings.font_color' | translate
      }}</label>
      <div class="k-form-field sam-form-control sam-full-width sam-flex-end">
         <kendo-colorpicker
            [format]="'hex'"
            [gradientSettings]="{ opacity: false }"
            [view]="'gradient'"
            [value]="(settings$ | async).tagEditFontColor"
            (valueChange)="fontColorChanged($event)"
         ></kendo-colorpicker>
         <samweb-clear-button [toolTipText]="'common.clear_color' | translate" (click)="clearFontColor()">
         </samweb-clear-button>
      </div>
   </div>
</div>

<h4 class="settings-header">{{ 'brick.brick_definitions.single_call_tag_editor.settings.header_tag' | translate }}</h4>
<div>
   <div class="sam-form-flex-row sam-border-box sam-padding-top">
      <samweb-configurable-editor-setting-part
         [selectedEditorType$]="selectedEditorType$"
         [configurableEditorSettings$]="configurableEditorSettings$"
         (editorSettingsChanged)="editorSettingsChanged($event)"
         (editorTypeSelected)="callTagTypeChanged($event)"
         class="k-form-field sam-form-control-full sam-flex-end"
         ><label fxFlex="40" class="align-center">{{
            'brick.brick_definitions.single_call_tag_editor.settings.tag_type' | translate
         }}</label>
      </samweb-configurable-editor-setting-part>
   </div>

   <div class="sam-form-flex-row sam-border-box">
      <label fxFlex="40" class="align-center">{{
         'brick.brick_definitions.single_call_tag_editor.settings.call_tag_id' | translate
      }}</label>
      <div class="k-form-field sam-form-control sam-form-control-full-width">
         <input
            (input)="callTagIdChanged($event.target.value)"
            [value]="(settings$ | async).callTagId"
            fxFlex="1 1 auto"
            kendoTextBox
         />
      </div>
   </div>

   <div class="sam-form-flex-row sam-border-box">
      <label fxFlex="40" class="align-center">{{
         'brick.brick_definitions.single_call_tag_editor.settings.call_tag_display_name' | translate
      }}</label>
      <div class="k-form-field sam-form-control sam-form-control-full-width">
         <input
            (input)="callTagDisplayNameChanged($event.target.value)"
            [value]="(settings$ | async).callTagDisplayName"
            [placeholder]="(settings$ | async).callTagId"
            fxFlex="1 1 auto"
            kendoTextBox
         />
      </div>
   </div>

   <div class="sam-form-flex-row sam-border-box">
      <label fxFlex="40" class="align-center">{{
         'brick.brick_definitions.single_call_tag_editor.settings.clear_tag_value' | translate
      }}</label>
      <div class="k-form-field sam-form-control sam-form-control-full-width">
         <input
            (input)="clearTagValueChanged($event.target.value)"
            [disabled]="(settings$ | async).readOnlyMode"
            [value]="(settings$ | async).clearTagValue"
            fxFlex="1 1 auto"
            kendoTextBox
         />
      </div>
   </div>
</div>

<div class="sam-form-row sam-padding-top">
   <label class="k-checkbox-label" for="tagSourceActiveCall">
      <input
         type="checkbox"
         id="tagSourceActiveCall"
         [checked]="(settings$ | async).showCallTagsForActiveCall"
         (click)="showCallTagsForActiveCallChanged($event.currentTarget.checked)"
         class="k-checkbox"
      />
      {{ 'brick.brick_definitions.single_call_tag_editor.settings.tag_source_active_call' | translate }}
   </label>

   <label class="k-checkbox-label" for="tagSourceCallHistory">
      <input
         type="checkbox"
         id="tagSourceCallHistory"
         [checked]="(settings$ | async).showCallTagsForHistoryCalls"
         (click)="showCallTagsForHistoryCallsChanged($event.currentTarget.checked)"
         class="k-checkbox"
      />
      {{ 'brick.brick_definitions.single_call_tag_editor.settings.tag_source_call_history' | translate }}
   </label>
   <label class="k-checkbox-label" for="showDialpad">
      <input
         type="checkbox"
         id="showDialpad"
         [checked]="(settings$ | async).readOnlyMode"
         (click)="isReadOnlyChanged($event.currentTarget.checked)"
         class="k-checkbox"
      />
      {{ 'brick.brick_definitions.single_call_tag_editor.settings.is_read_only' | translate }}
   </label>
</div>

<h4 class="settings-header">{{ 'brick.brick_definitions.single_call_tag_editor.settings.header_info' | translate }}</h4>
<div>
   <div class="sam-form-row">
      <div class="sam-margin-top">
         <label class="k-checkbox-label" for="showDescriptionTextAsPopover">
            <input
               type="checkbox"
               id="showDescriptionTextAsPopover"
               [checked]="(settings$ | async).showDescriptionTextAsPopover"
               (click)="showDescriptionTextAsPopoverChanged($event.currentTarget.checked)"
               class="k-checkbox"
            />
            {{ 'brick.brick_definitions.single_call_tag_editor.settings.show_description_text_as_popover' | translate }}
         </label>
      </div>
      <kendo-editor
         (valueChange)="tagEditorDescriptionChanged($event)"
         [value]="tagEditorDescription"
         [style.width]="'100%'"
         [style.height]="'200px'"
         [iframe]="false"
      ></kendo-editor>
   </div>
</div>

<!--  fix for correct behaviour of kendo-editor in scrollbar -->
<textarea class="kendo-editor-fix"></textarea>
